import { Question } from "./Question"
import { ScaleLegend } from "./ScaleLegend"
import { RadioButtonAnswer } from "./RadioButtonAnswer"

export function RadioPrompt({
    options,
    scaleStart,
    scaleEnd,
    questionText,
    field,
    includeNA,
    naValue,
    data,
    emptyError,
    handle,
    sectionName,
    isRequired=true,
}) {
    return (
        <>
            <Question questionText={questionText} />
            <div className="w-100 py-5">
                {scaleStart && scaleEnd && <ScaleLegend first={scaleStart} last={scaleEnd} />}
                <RadioButtonAnswer
                    field={field}
                    data={data}
                    handle={handle}
                    options={options}
                    includeNA={includeNA}
                    naValue={naValue}
                    emptyError={emptyError}
                    isRequired={isRequired}
                />
            </div>
            {emptyError && isRequired && <span className="text-danger mt-n5">Selection is required</span>}
        </>
    )
}
